import React, {useContext} from 'react'
import { Row, Col } from "antd";
import { ScheduleOutlined, ContactsOutlined } from '@ant-design/icons';
import { AppContext } from '../../util/context';

export const ATMenu = ({current, setCurrent}) => {
    const {
        StyledDiv
    } = useContext(AppContext);
    return (
        <>
            <Row
                className={"atMenuNoRep"}
            >

                <Col
                    xl={{span: 4}}
                    lg={{span: 6}}
                    md={{span: 6}}
                    sm={{span: 12}}
                    xs={{span: 12}}
                    style={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "start",
                        padding: "10px"
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                        }}
                        className="atMenuContainer"
                        onClick={() => {
                            setCurrent("myactions")
                        }}
                    >
                        <ScheduleOutlined className={current === "myactions" ? "atMenuIconSelected" : "atMenuIcon"} />
                        <StyledDiv
                            className={current === "myactions" ? "atMenuTextSelected" : "atMenuText"}
                        >
                            SUBMITTED ACTIONS
                        </StyledDiv>
                    </div>
                </Col>

                <Col
                    xl={{span: 4}}
                    lg={{span: 6}}
                    md={{span: 6}}
                    sm={{span: 12}}
                    xs={{span: 12}}
                    style={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "start",
                        padding: "10px"
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                        }}
                        className="atMenuContainer"
                        onClick={() => {
                            setCurrent("assignedactions")
                        }}
                    >
                        <ContactsOutlined className={current === "assignedactions" ? "atMenuIconSelected" : "atMenuIcon"} />
                        <StyledDiv
                            className={current === "assignedactions" ? "atMenuTextSelected" : "atMenuText"}
                        >
                            ASSIGNED ACTIONS
                        </StyledDiv>
                    </div>
                </Col>
            </Row>
        </>
    )
}
